import React from 'react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Login/Login.css';
import { useDispatch, useSelector } from 'react-redux';
import CONSTANTS from '../util/constants';


const ForgotPassword = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const email = useSelector((state) => state.login.email);
    const forgotPasswordResponse = useSelector((state) => state.login.forgotPasswordResponse);

    useEffect(() => {
        
        if (forgotPasswordResponse && forgotPasswordResponse != null && forgotPasswordResponse != 'Failed') {
            navigate('/ResetPassword');
        }

    }, [forgotPasswordResponse]);

    const changeEmail = (e) => {
        const val = e.target.value;
        dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL, payload: { value: val } })
        dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_EMAIL_ERROR, payload: { value: false } })

    }

    const forgotPasswordClick = () => {
        if (email == '') {
            alert('Please enter the Email Id')
        }
        else {
            const forgotPassPayload = {
                email: email
            }
            dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL, payload: { value: '' } })
            dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_FORGOT_PASSWORD_API_CALL, payload: { value: forgotPassPayload } })
        }
    }

    return (
        <section>
            <div className="page-header col-md-12 tabmargin tab-center" style={{
                position: 'absolute', left: '50%', top: '30%',
                transform: 'translate(-50%, -50%)', height: '60% !important'
            }}>
                <div className="container">
                    {/* <h3 className="font-weight-bolder  text-gradient text-info text-center"  >SIGN IN</h3> */}
                    <div className="row">

                        <div className="col-md-3 col-3" style={{ height: '100%' }} />
                        <div className="col-md-6 col-6" style={{ height: '100%' }}>
                            <div className="card card-plain mt-12" >

                                <div
                                    style={{ width: '100%', padding: 0 }}
                                    onClick={() => {
                                        dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL, payload: { value: '' } })
                                        dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_FORGOT_PASSWORD_API_RESPONSE, payload: { value: null } })
                                        navigate('/');
                                    }}

                                    className="form-check">
                                    <label className="form-check-label" htmlFor="back"> {`< Back to Login`}</label>
                                </div>
                                <div className="card-header text-center pt-4 px-lg-4 px-2">
                                    <label style={{ fontSize: 16, color: 'black', textAlign: 'center' }}>{'Forgot Password'}</label>
                                </div>
                                <div className="card-body" style={{ border: '1HN FbFFRT4solid black !important' }}>

                                    <form role="form">
                                        <label>Email</label>
                                        <div className="mb-3">
                                            <input type="email" className="form-control" placeholder="Email" aria-label="Email" aria-describedby="email-addon" maxLength={50} onChange={changeEmail} value={email}
                                            />
                                        </div>


                                        <div className="text-center" style={{}}>
                                            <button type="button" className="btn col-md-4" style={{ borderRadius: 4, borderColor: '#17a2b8', color: 'white', background: "linear-gradient(300deg,#2152ff,#21d4fd)" }} onClick={() => { forgotPasswordClick() }}>Submit</button>
                                        </div>
                                    </form>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 col-3" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ForgotPassword;